<template>
  <v-layout>
    <v-switch
      :label="field.label"
      v-model="$parent.entity[field.name]"
      :disabled="field.disabled"
    >
    </v-switch>
  </v-layout>
</template>

<script>
export default {
  name: "SwitchField",
  props: ["field", "value"]
};
</script>

<style scoped></style>
